module.exports = __webpack_public_path__ + "static/media/overview.c6f0bb0d.png";